import ViewBase from "../view-base.view";
import DatePickerComponent from "../../components/date-picker/date-picker.component";
import moment from "moment";
import { formats as FORMATS } from '../../config/constants';
import AttendanceModel from "../../models/attendance/attendance.model";

export default function AttendanceExcelDownloadView() {

  ViewBase.call(this);

  let data;
  let maxDownloadableDays = ""

  const downloadExcel = (e) => {
    e.preventDefault();

    // Validate upload form
    e.target.classList.add('was-validated');
    if (!e.target.checkValidity()) {
      e.stopPropagation();
      return;
    }

    this.showLoading();
    const params = {
      sortBy: "",
      orderBy: "",
      pageIndex: 0,
      pageSize: 300,
      fromDate: moment(data.fromDate).format(FORMATS.apiDateFormat),
      toDate: moment(data.toDate).format(FORMATS.apiDateFormat),
      bu: data.bu,
      saleForceType: data.saleForceType,
      divisionGroup: data.divisionGroup,
      workType: data.workType,
      attendanceAbnormalType: data.attendanceAbnormalType,
      userId: data.userId,
      userRoleCode: data.userRoleCode,
      siteGroupId: data.siteGroupId,
      includePhoto: data.includePhoto
    }
    const fileName = `Attendance List - ${moment().format('YYYYMMDDHHmm')}.xlsx`
    return AttendanceModel.downloadAttendance(params, fileName)
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  const onDatePickerChange = (e) => {
    data.fromDate = moment(e.detail.start).format(FORMATS.dateFormat);
    data.toDate = moment(e.detail.end).format(FORMATS.dateFormat);
  }

  let closeModal = function () {
    onClose(false);
  }

  let onClose = (isModalOpen) => { }

  return {
    oninit: (vnode) => {
      if (vnode.attrs.onClose) {
        onClose = vnode.attrs.onClose;
      }

      if (vnode.attrs.data) {
        // console.log('data========>', vnode.attrs.data)
        data = vnode.attrs.data;
      }
    },
    // onupdate: (vnode) => {
    //   if (vnode.attrs.data) {
    //     console.log('data========>', vnode.attrs.data)
    //     data = vnode.attrs.data;
    //   }
    // },
    view: (vnode) => {
      return [
        m('.container',
          m('form.row.g-3.needs-validation[novalidate]', { onsubmit: downloadExcel },
            m('.col-12',
              m('label.form-label[for=export-date-range]', this.getText("LT00000070", "Date Range")),
              m(DatePickerComponent, {
                id: 'export-date-range',
                class: 'form-control',
                isRange: true,
                minDays: 1,
                maxDays: maxDownloadableDays ? maxDownloadableDays : 31,
                dateStart: data?.fromDate ? moment(data.fromDate).format(FORMATS.dateFormat) : moment().format(FORMATS.dateFormat), // default date range
                dateEnd: data?.toDate ? moment(data.toDate).format(FORMATS.dateFormat) : moment().format(FORMATS.dateFormat), // default date range
                required: true,
                onselect: (e) => {
                  onDatePickerChange(e);
                }
              })
            ),
            m('.col-12',
              m('div', m('label.form-label[for=export-date-range]', this.getText("LT00000990", "Include photos")),
                m('input.form-check-input[type="checkbox"].ms-2',
                  {
                    checked: data.includePhoto || false,
                    onchange: e => {
                      data.includePhoto = e.target.checked
                      if (e.target.checked) {
                        const fromDate = vnode.attrs.data.fromDate;
                        const toDate = vnode.attrs.data.toDate;
                        data.fromDate = fromDate ? moment(fromDate).format(FORMATS.dateFormat) : moment().subtract(1, 'week').format(FORMATS.dateFormat);
                        data.toDate = toDate ? moment(toDate).format(FORMATS.dateFormat) : moment().format(FORMATS.dateFormat);
                        maxDownloadableDays = 7;
                      } else {
                        if (maxDownloadableDays) {
                          maxDownloadableDays = null;
                        }
                      }
                    }
                  }
                ),
                data.includePhoto && m("p.m-0", { style: { color: '#ff9800' } }, "Remarks: You can only download up to 7 days data.")
              ),
            ),
            m('.col-12',
              m('.d-flex.justify-content-end.align-items-center',
                m('div',
                  m('button.btn.btn-primary[type=submit]', this.getText("LT00000492", "Download")),
                  m('button.btn.btn-white[type=button].ms-2', { onclick: closeModal }, this.getText("LT00000021", "Close")),
                )),
            ),
          ),
        ),
        this.getBaseViews()
      ]
    }
  }
}
